import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';

import { DaysLeft } from './DaysLeft';
import { ProgressBar } from './ProgressBar';

interface ProjectCardProps {
  title: string;
  thumbnailUrl: string;
  businessId: number;
  /** 남은 날자수 */
  daysLeft: number;
  donationAmount: number;
  achievementRate: number;
  institution?: {
    id: number;
    logoUrl: string;
    name: string;
  };
  isEnded?: boolean;
  onProjectLinkClick?: () => void;
}

export const ProjectCard = ({
  title,
  thumbnailUrl,
  businessId,
  daysLeft,
  donationAmount,
  achievementRate,
  institution,
  isEnded,
  onProjectLinkClick,
}: ProjectCardProps) => {
  return (
    <article className="overflow-hidden rounded-xlarge border border-Gray-300">
      <CustomLink
        href={DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
          id: businessId,
        })}
        aria-label="지정기부사업 상세 페이지로 이동"
        onClick={onProjectLinkClick}
        className="relative block aspect-[335/180] w-full"
      >
        <Image
          fill
          sizes={`${BREAKPOINTS.MOBILE} 100vw, ${BREAKPOINTS.TABLET} 50vw, 314px`}
          src={thumbnailUrl}
          alt={title}
          className="object-cover"
        />
      </CustomLink>
      <div className="px-20 py-16">
        <div
          className={cn('mb-8 flex items-center justify-between', {
            'justify-end': !institution,
          })}
        >
          {institution ? (
            <CustomLink
              href={DONATION_ROUTES.HOMETOWNS_DETAIL.withSearchParams({
                dynamicPath: {
                  id: institution.id,
                },
                searchParams: {
                  tab: 'projects',
                },
              })}
              aria-label="지자체 상세 페이지로 이동"
              className="flex items-center gap-4"
            >
              <Image
                className="size-20 rounded-pill border border-Gray-300"
                src={institution.logoUrl}
                alt={institution.name}
                width={20}
                height={20}
              />
              <span className="mt-1 font-600 text-Gray-600 typo-caption1">
                {institution.name}
              </span>
              <SvgChevronright className="size-12 text-Gray-600" />
            </CustomLink>
          ) : null}

          <DaysLeft value={daysLeft} isEnded={isEnded} />
        </div>
        <CustomLink
          href={DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
            id: businessId,
          })}
          aria-label="지정기부사업 상세 페이지로 이동"
          className="mb-16 line-clamp-2 w-fit overflow-hidden text-ellipsis font-600 text-Gray-black typo-body3"
          onClick={onProjectLinkClick}
        >
          {title}
        </CustomLink>
        <ProgressBar progress={achievementRate} />
        <div className="mt-10 flex h-30 items-center justify-between gap-2 font-700 typo-body3">
          <span className="text-R-500">{achievementRate}%</span>
          <span className="text-Gray-black">
            {donationAmount.toLocaleString()} 원
          </span>
        </div>
      </div>
    </article>
  );
};
